import { BasicAuthServiceHelper } from '@/modules/Auth'
import { flattenHydraCollection, HydraSearchParams, IRI } from 'emt-library'
import {
  generateDefaultFiltersValues,
  SearchFiltersValues,
  SearchResults,
  SearchType,
} from '@/modules/Search/apiTypes/base'
import { Search } from './apiTypes'
import { Address } from '@/dataV3/Common/Address'
import { ObjectKeys } from '@/utils'

type SearchProfileParamsType = HydraSearchParams & {
  userAddress?: Address | null
  type: SearchType
  filters?: SearchFiltersValues
  latitude?: number
  longitude?: number
}

export const searchProfilesAsync = async (
  isOwner: boolean,
  params: SearchProfileParamsType,
  nextPage?: string,
): Promise<SearchResults> => {
  if (nextPage) {
    return searchProfilesNextPageAsync(nextPage)
  }

  const {
    userAddress,
    type,
    filters = generateDefaultFiltersValues(),
    page = 1,
    itemsPerPage = 8,
    longitude = userAddress?.longitude,
    latitude = userAddress?.latitude,
  } = params

  const route = isOwner ? Search.MemberRoute : Search.AnimalRoute

  const searchParams: Search.SearchParams = {
    ...filters,
    ...{
      latitude,
      longitude,
    },
    type,
    itemsPerPage,
    page,
  }

  ObjectKeys(searchParams).forEach((key) => {
    if (searchParams[key] === undefined || searchParams[key] === false) {
      delete searchParams[key]
    }
  })

  return flattenHydraCollection(
    await BasicAuthServiceHelper.requestAuthenticatedV2Async<Search.Response, never, never, Search.SearchParams>(
      route,
      { searchParams },
    ),
  )
}

export const searchProfilesNextPageAsync = async (nextPage: IRI): Promise<SearchResults> => {
  return flattenHydraCollection(
    await BasicAuthServiceHelper.requestAuthenticatedV2Async<Search.Response>(Search.NextPageRoute(nextPage)),
  )
}
